export default "__VITE_ASSET__B23t_V8___"